import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import {
  INDUSTRY_SECTORS,
  NATURE_OF_ACTIVITIES,
} from "data/standards/griStandards";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import {
  industrailIdentification,
  natureOfActivities,
} from "data/reports/relevantReports";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import {
  DIGITAL_FIELD_NOTES_FORM_STEP_1,
  SMART_AI_FIELD_NOTES_TEMPLATE_STEP_2,
  ESG_REPORTING_COMPLIANCE_FORM_S3,
  HAZARD_IDENTIFICATION_HIRA_JSA_FORM,
  Hazard_Identification_Step_3,
} from "data/forms/griFormSchema";
import {
  MOM_TEMPLATES,
  HIRA_JSA_BASE_TEMPLATE,
} from "data/templates/smartTemplateData";
import SmartTemplate from "components/customizedStandardsComponent/SmartTemplate";

const HazardIdentification = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const locationData = useLocation();
  const navigationRoute = useNavigate();
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const steps = ["d", "d", "d"];
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const HandleNavigation = () => {
    navigationRoute(locationData?.state?.route || locationData.pathname);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const handleBackFromStandardsSelector = (
    selectedStandards,
    activityDetails
  ) => {
    // Save any data before going back
    if (selectedStandards && selectedStandards.length > 0) {
      setReportData((prev) => ({
        ...prev,
        selectedStandards,
      }));
    }
    handleBack();
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <ReusableFormComponent
            {...HAZARD_IDENTIFICATION_HIRA_JSA_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showReportCountdownButton={false}
            showDownloadButton={false}
          />
        );
      case 1:
        return (
          <SmartTemplate
            {...HIRA_JSA_BASE_TEMPLATE}
            onNext={handleNext}
            onPrevious={handleBack}
            // onSave={handleMoMSave}
            showPreviousButton={true}
            nextButtonText="Synchronize with ESG Reporting Dashboard"
            downloadButtonTitle="Download filled MoM Report"
          />
        );
      case 2:
        return (
          <StandardsSelector
            standards={Hazard_Identification_Step_3}
            title="Auto-Synced to ESG Vision Dashboard"
            onNext={(selected) => console.log("Selected Standards:", selected)}
            showReportCountdownButton={false}
            onBack={handleBackFromStandardsSelector}
            showBackButton={true}
            showNextButton={false}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg7_1"
                title={locationData?.state?.label || ""}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default HazardIdentification;
